<template>
  <div class='products'>
    <form class="form form-inline float-right mr-5">
      <button-group :p-button-group="buttonGroup"></button-group>
      <search-group :p-search-group="searchGroup"></search-group>
    </form>
    <div class='clearfix'></div>

    <pager v-bind:items='products || []' :count="item_count"></pager>

    <div class="">
      <table class='table table-sm table-hover' v-if="isAdmin || isFinance">
        <thead class="thead-default">
          <th>公司</th>
          <th>产品名</th>
          <th>尺寸(mm)</th>
          <th>基础P数</th>
          <th>基础价格</th>
          <th>加P价格</th>
          <th>包装费</th>
          <th>基础重量(kg)</th>
          <th>邮费</th>
          <th>操作</th>  
          <th>创建时间</th>
        </thead>
        <tbody>
          <tr v-for="product in products">
            <td>{{product.company.nickname}}</td>
            <td>
              <img :src="product.thumbnail" style="height:40px" v-if="product.thumbnail">
              <router-link :to="'/orders?product_code=' + product.product_code">{{product.name}}</router-link>
              <br>{{product.product_code}}
            </td>
            <td>{{product.meta.width}} X {{product.meta.height}}</td>
            <td>{{product.meta.base_page_count}}</td>
            <td>{{product.meta.fee_base}}元</td>
            <td>{{product.meta.fee_extra_page}}元</td>
            <td>{{product.meta.fee_packaging}}元</td>
            <td>{{product.meta.weight}}</td>
            <td>
              <span v-if="product.meta.delivery_fee_free">包邮或统一结算邮费</span>
              <span v-else="product.meta.delivery_fee_free">不包邮</span>
            </td>
            <td>
              <button class="btn btn-sm btn-primary" @click="$refs.editMainProductRef.showEditMainProductModal(product)">设置</button>
              <button class="btn btn-sm btn-primary" @click="editProduct(product)">子产品</button>
            </td>
            <td><local-time :time="product.created_at"></local-time></td>
          </tr>
        </tbody>
      </table>
      <table class="table table-sm table-hover" v-else>
        <thead>
          <tr>
            <th>公司</th>
            <th>产品名</th>
            <th>尺寸(mm)</th>
            <th>创建时间</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in products">
            <td>{{product.company.nickname}}</td>
            <td><router-link :to="'/orders?product_code=' + product.product_code">{{product.name}}</router-link></td>
            <td>{{product.meta.width}} X {{product.meta.height}}</td>
            <td><local-time :time="product.created_at"></local-time></td>
          </tr>
        </tbody>
      </table>
    </div>

    <edit-main-product ref="editMainProductRef" v-on:refresh="loadData"></edit-main-product>
    
    <b-modal
      size="lg"
      ref="editProductRef"
      hide-header
      ok-only
      ok-title="关闭"
      editProductRef
      id="modal-edit-product">
      <edit-product :main-product-code="hotProduct ? hotProduct.product_code : null"></edit-product>
    </b-modal>


  </div>
</template>

<script>
import ButtonGroup from '@/components/_partial/ButtonGroup'
import SearchGroup from '@/components/_partial/SearchGroup'
import Pager from './_partial/Pager'
import LocalTime from '@/components/_small/LocalTime'
import EditMainProduct from '@/components/_products/EditMainProduct'
import EditProduct from '@/components/_products/EditProduct'
import OrderMixin from '@/mixins/order'
import RoleMixin from '@/mixins/role'
import LoadDataMixin from '@/mixins/load_data'

function computeSearchGroup () {
  return {
    name: '产品名',
    key: 'name',
    value: '',
    menus: [{
      name: '产品名',
      key: 'name'
    }]
  }
}

function editProduct (mainProduct) {
  this.hotProduct = mainProduct
  this.$refs.editProductRef.show()
}

function loadData () {
  // Make a request for a user with a given ID
  this.$http.doSpin()
  this.$http.get('/api/main_products' + location.search).then(response => {
    this.$http.cancelSpin()
    this.item_count = response.data.count
    this.products = response.data.data
  })
  .catch(function (error) {
    this.$http.cancelSpin()
    console.log(error)
  })
}

export default {
  name: 'products',
  mixins: [OrderMixin, RoleMixin, LoadDataMixin],
  data () {
    return {
      'item_count': -1,
      products: [],
      hotProduct: null
    }
  },
  methods: {
    loadData,
    editProduct,
    computeSearchGroup
  },
  mounted () {
    this.loadData()
  },
  components: {
    Pager,
    LocalTime,
    EditMainProduct,
    EditProduct,
    SearchGroup,
    ButtonGroup
  },
  computed: {
    buttonGroup () {
      return this.computeCompanyButtonGroup()
    },
    searchGroup () {
      return this.computeSearchGroup()
    }
  }
}
</script>